// Deterministically maps a product to one of 6 honey-color gradient classes
// (defined in App.css as .grade-1 .. .grade-6), so a product without a photo
// still renders as a consistent, distinct color rather than a repeated placeholder.
export function gradeClassFor(product) {
  const key = String(product?.id ?? product?.name ?? "");
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return `grade-${(hash % 6) + 1}`;
}
